import classes from "./FooterAds.module.scss";
import AdUnit, { AdUnitTypeEnum } from "./AdUnit";
import { FooterEnum } from "./config/units/footer";
import { memo } from "react";
import { useExperiment } from "@/common/hooks/useExperiment";
import { EXPERIMENT_NO_ADS } from "@/common/services/experiment/constants";

export const FooterAds = memo(() => {
  const { isLoading, variant: noAds } = useExperiment({ key: EXPERIMENT_NO_ADS, fallback: false });

  if (noAds || isLoading) {
    return null;
  }

  return (
    <div className={classes.advertFooter}>
      <AdUnit name={FooterEnum.DesktopIndexFooterA} type={AdUnitTypeEnum.DESKTOP} />
      <AdUnit name={FooterEnum.DesktopIndexFooterB} type={AdUnitTypeEnum.DESKTOP} />
      <AdUnit name={FooterEnum.DesktopIndexFooterC} type={AdUnitTypeEnum.DESKTOP} />
      <AdUnit name={FooterEnum.MobileFooter} type={AdUnitTypeEnum.MOBILE} />
    </div>
  );
});
